import { useTranslation } from 'react-i18next';
import { currentLocale } from '@/i18n';

/* Masthead language toggle: shows the other language as a small-caps text button. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');
  const locale = currentLocale();
  let nextLanguage = 'en';
  let label = 'EN';
  if (locale === 'en') {
    nextLanguage = 'zh-CN';
    label = '中文';
  }
  return (
    <button
      type="button"
      aria-label={t('language')}
      lang={nextLanguage}
      onClick={() => { void i18n.changeLanguage(nextLanguage); }}
      className="min-h-6 whitespace-nowrap text-xs uppercase tracking-[0.14em] text-ink-2 transition-colors hover:text-ink"
    >
      {label}
    </button>
  );
}
